import { render, staticRenderFns } from "./Os.vue?vue&type=template&id=6ef5b174&scoped=true"
import script from "./Os.vue?vue&type=script&lang=js"
export * from "./Os.vue?vue&type=script&lang=js"
import style0 from "./Os.vue?vue&type=style&index=0&id=6ef5b174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5b174",
  null
  
)

export default component.exports